export default __webpack_public_path__ + "static/media/icon7.b26346e2.png";